/* eslint no-template-curly-in-string: 0 */

import paperCheckIcon from "../../assets/images/paper-check-2.png";
import { PAYMENT_NETWORKS, FLOW_TYPES } from "../../utils/enums";

export const paperCheck = {
  id: PAYMENT_NETWORKS.PAPER_CHECK,
  displayName: "check",
  paywall: {
    tile: {
      displayName: ["Check by Mail"],
      tagline: ["Mails in 4-6 weeks. US recipients only"],
      description: "Sent via USPS to your mailing address",
      logo: paperCheckIcon
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.COLLECT_ADDRESS,
    title: "Check by Mail",
    description: [
      {
        string: "Please confirm your mailing address to receive a paper check. <br />Expect 4-6 weeks for check delivery. "
      },
    ],
  },
  acceptPayment: {
    title: ["Confirm Payment"],
    autoAcceptDurationInSeconds: 10,
    flow: FLOW_TYPES.ACCEPT_PAYMENT.COLLECT_ADDRESS,
    description: "Please confirm that your mailing address is correct as it appears below. Once submitted, the delivery address cannot be changed.",
    btnLabel: 'SUBMIT',
    imgSrc: paperCheckIcon,
  },
  networkSelectionAccepted: {
    imgSrc: paperCheckIcon,
    title: ["Success!"],
    description: [
      "Please check your email",
      " for details regarding your ",
      {
        string: "${paymentNetwork.displayName}",
        props: {
          className: 'payment-paymentNetwork',
        }
      },
      " for ",
      {
        string: "${payment.acceptedAmount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.acceptedCurrency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      ". Your check should be processed and mailed within 4-6 weeks."
    ],
    secondaryText: " "
  },
  paymentComplete: {
    title: "Payment Complete",
    initial: {
      description: [
        "Success! A check in the amount of ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        " will be mailed to your address on file in approximately 4-6 weeks."
      ],
      secondaryText: [
        "A confirmation will be ",
        {
          string: "${payment.recipientNotificationPreference}",
          transformations: [
            {
              type: 'formatPaymentNetworkRecipientType',
            }
          ],
        },
        {
          string: "${payment.recipientNotificationPreference}",
          transformations: [
            {
              type: 'formatEmailAddressOrMobilePhoneNumber',
            },
          ],
          props: {
            className: 'payment-recipientEmail'
          }
        },
        "."
      ]
    },
    revisit: {
      description: [
        "Please check your email ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: "payment-recipientEmail"
          }
        },
        " for details regarding your payment for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount"
          }
        },
        ". A paper check will be mailed to the address on file approximately 4-6 weeks from ",
        {
          string: "${payment.updatedAt}",
          transformations: [
            {
              type: "formatDate"
            }
          ],
          props: {
            className: "payment-updatedAt"
          }
        },
        "."
      ],
      secondaryText: " "
    },
    imgSrc: paperCheckIcon
  }
};

export default paperCheck;
